import React, { FC } from 'react';

import { FormikProps } from 'formik';
import PasswordField from '../../../../FormFields/PasswordField';
import { SignUpFormData } from '../../../../../models/auth/@types';
import Typo from '../../../../Typo';
import { getFieldError } from '../../../../FormFields/Utils';
import styles from './mentorCode.module.sass';

export interface MentorCodeProps {
  mentorCodeKey: string;
  formikProps: FormikProps<Partial<SignUpFormData>>;
}

const MentorCode: FC<MentorCodeProps> = props => {
  const { mentorCodeKey, formikProps } = props;
  const errors = {
    mentorCode: getFieldError(mentorCodeKey, formikProps),
  };
  return (
    <div className={styles.mentorCodeRoot}>
      <Typo normal bold classes="mb-1 is-block">
        Enter mentor code
      </Typo>
      <Typo small classes={styles.subtitle}>
        Please enter the code you received from NAF for approved mentors
      </Typo>
      <PasswordField
        valueKey={mentorCodeKey}
        rootClassName={`${styles.mentorCodeField} mb-5`}
        otherFieldProps={{
          placeholder: 'Mentor Code',
          onChange: formikProps.handleChange,
          onBlur: formikProps.handleBlur,
          value: formikProps?.values?.mentorCode,
        }}
        error={errors.mentorCode}
        hidePasswordByDefault
      />
    </div>
  );
};

export default MentorCode;
